module.exports = __webpack_public_path__ + "img/ic_privacy_and_consent.033e593a.svg";